const CONTEXTS = {
    BANNER_LIST: 'BannerList',
    CONTAINER: 'Container',
    GRID: 'Grid',
    MODAL: 'Modal'
};

const PAGE_TYPES = {
    BRAND: 'PageBrand',
    CATEGORY: 'PageCategory',
    CONTENT: 'PageContent',
    SEARCH: 'PageSearch',
    HAPPENING: 'PageHappening'
};

const PAGE_TYPE_PATHS = {
    [PAGE_TYPES.BRAND]: '/brand/',
    [PAGE_TYPES.CATEGORY]: '/shop/',
    [PAGE_TYPES.CONTENT]: '/beauty/',
    [PAGE_TYPES.SEARCH]: '/search?keyword=',
    [PAGE_TYPES.HAPPENING]: '/happening/'
};

const ACTION_TYPES = {
    EXTERNAL: 'ActionLinkExternal',
    INTERNAL: 'ActionLinkInternal',
    MODAL: 'Modal',
    ACTION_CUSTOM: 'ActionCustom'
};

const CUSTOM_ACTION_TYPES = {
    SIGN_IN: 'SignIn'
};

const CAROUSELS_WITH_PRICE_CONFIG = {
    'Chosen For You': true,
    'Just Dropped': true,
    'Selling Fast': true,
    'Choisis pour vous': true,
    'S’envole rapidement': true
};

const RENDERING_TYPE = {
    GAME_DETAILS: 'gameDetails',
    RMN_BANNER: 'RMNBanner',
    RMN_CAROUSEL: 'RMNCarousel',
    HAPPENING_EVENTS_GRID: 'HappeningEventsGrid',
    CS_CHAT_WITH_US: 'CS_chatWithUs',
    CS_CALL_US: 'CS_callUs',
    CS_EMAIL_US: 'CS_emailUs',
    CS_ORDER_STATUS: 'CS_orderStatus'
};

const SECTION_COMPONENTS_TYPE = {
    CARD: 'CardRendering',
    COPY: 'Copy',
    BANNER: 'Banner'
};

const SECTION_LAYOUT_TYPE = {
    GRID: 'grid',
    CAROUSEL: 'carousel'
};

module.exports = {
    CONTEXTS,
    PAGE_TYPES,
    PAGE_TYPE_PATHS,
    ACTION_TYPES,
    CUSTOM_ACTION_TYPES,
    CAROUSELS_WITH_PRICE_CONFIG,
    COMPONENT_TYPES: {
        ANCHOR: 'Anchor',
        BANNER: 'Banner',
        BANNER_LIST: 'BannerList',
        BLOCK_ENTRY_STYLE: 'BlockEntryStyle',
        COPY: 'Copy',
        DIVIDER: 'Divider',
        INLINE_ENTRY_STYLE: 'InlineEntryStyle',
        LINK: 'Link',
        PRODUCT_LIST: 'ProductList',
        PROMOTION_LIST: 'PromotionList',
        RECAP: 'Recap',
        REWARD_LIST: 'RewardList',
        SECTION_HEADING: 'SectionHeading',
        SOFT_LINKS: 'SoftLinks',
        SECTION: 'SectionRendering',
        CUSTOM_RENDERING: 'CustomRendering',
        UGC_WIDGET: 'UgcWidget'
    },
    RECAP_CAROUSEL: {
        ITEM_URLS: {
            BASKET: '/basket',
            LOVES: '/shopping-list',
            PURCHASE_HISTORY: '/purchase-history',
            RECENTLY_VIEWED: '/recently-viewed',
            BEAUTY_RECOMMENDATIONS: '/in-store-services'
        }
    },
    PRODUCT_LIST_GROUPING: {
        SHOW_ADD_BUTTON: 'Show Add Button',
        SHOW_PRICE: 'Show Price',
        SHOW_MARKETING_FLAGS: 'Show Marketing Flags',
        SHOW_RANKING_NUMBERS: 'Show Ranking Numbers',
        SHOW_LOVES_BUTON: 'Show Loves Button',
        SHOW_RATING_WITH_TOTAL_COUNT: 'Show Rating with total count'
    },
    COMPONENT_SPACING: {
        XS: [2, 4],
        SM: [4, 5],
        MD: [5, 6],
        LG: [6, 7]
    },
    DIVIDER_SIZE: {
        SM: 'small',
        LG: 'large'
    },
    RENDERING_TYPE,
    SECTION_COMPONENTS_TYPE,
    SECTION_LAYOUT_TYPE
};
